// Preload CSS resources from entrypoints.json manifest
// This is not specific to Barba.js, but improve it's performance.


// Request budget
const requestBudget = 50
//Preload support (firefox doesn't support preload)
const supportPreload = navigator.userAgent.search("Firefox") === -1



/**
 * Retreive CDV query
 */
const cdvQuery = (function(str) {
    const match = str.match(/[?&](cdv=[0-9]+)/m)
    return match ? `?${match[1]}` : ""
})(document.querySelector('link[href*="?cdv="],link[href*="&cdv="]').getAttribute("href"))



/**
 * Fetch the entrypoints.json 
 */
fetch(`/dist/entrypoints.json${cdvQuery}`).then(response => {
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json().then(parseEntrypoints)
    }
})



/**
 * Parse entrypoints for chunks to preload (or prefetch)
 */
function parseEntrypoints(json) {
    let chunks = []

    for (const [entrypoint, entrypointChunks] of Object.entries(json)) {
        // Skip "assets" entry, this is a special case   
        // which should never be required.
        if (entrypoint === "assets") {
            continue
        }
        // Each chunk in entrypoint...
        entrypointChunks.forEach(chunk => {
            // ... if entrypoint is from *.scss, skip *.js chunk
            if (entrypoint.startsWith("css-") && chunk.endsWith('.js')) {
                return
            }
            // ... if already loaded, skip
            if (document.querySelector(`[data-chunk="${chunk}"]`)) {
                return
            }
            // ... add to chunks listing if not included
            if (!chunks.includes(chunk)) {
                chunks.push(chunk)
            }
        })
    }

    if (location.host === 'devinci.local.sigmund.ca') {
        if (chunks.length > requestBudget) {
            console.info(`%c Preloaded ${chunks.length} entrypoints chunks, budget is ${requestBudget}.`, 'color: #e8505b')
        } else {
            console.info(`%c Preloaded ${chunks.length} entrypoints chunks.`, 'color: #14b1ab')
        }
    }
    
    chunks.filter(x => x.endsWith('.css')).forEach(chunk => {
        appendLink(`/dist/${chunk}${cdvQuery}`, 'preload', 'style')
    })

    chunks.filter(x => x.endsWith('.js')).forEach(chunk => {
        appendLink(`/dist/${chunk}${cdvQuery}`, 'prefetch', 'script')
    })
}



/**
 * Append a link to the head
 */
function appendLink(href, rel, as) {
    let l = document.createElement("link");
    l.rel = supportPreload ? rel : "prefetch";
    l.as = as;
    l.href = href;
    document.head.appendChild(l);
}
